
<div class="embed-visual__info">
  <div class="fs-14 bold c-text-color-dark pb-10 border-b-dotted-1 bc-grey-1 mb-12 user-select-none">
    <span>Details</span>
  </div>
  @if (loading()) {
    <div>
      <loading-rect size="100% 20px" class="value d-inline-block br-4 mb-4"></loading-rect>
      <loading-rect size="100% 20px" class="value d-inline-block br-4 mb-4"></loading-rect>
      <loading-rect size="100% 20px" class="value d-inline-block br-4 mb-4"></loading-rect>
      <loading-rect size="100% 20px" class="value d-inline-block br-4 mb-4"></loading-rect>
      <loading-rect size="100% 20px" class="value d-inline-block br-4 mb-4"></loading-rect>
      <loading-rect size="100% 20px" class="value d-inline-block br-4 mb-4"></loading-rect>
      <loading-rect size="100% 20px" class="value d-inline-block br-4 mb-4"></loading-rect>
      <loading-rect size="100% 20px" class="value d-inline-block br-4 mb-4"></loading-rect>
      <loading-rect size="100% 20px" class="value d-inline-block br-4 mb-4"></loading-rect>
    </div>
  }
  @else {
    <div class="embed-visual__info-sections">
      @for (s of sections(); track s.title) {
        <div class="embed-visual__info-section">
          <div class="embed-visual__info-label user-select-none" [title]="s.title">{{s.title}}:</div>
          <div class="embed-visual__info-value"
               [class.text-ellipsis]="s.nowrap"
               [title]="s.items.length == 1 ? (s.items[0].tooltip ?? s.items[0].title) : ''">
            @for (i of s.items; track $index) {
              <span [title]="i.tooltip ?? i.title" [class.c-red]="i.invalid">
                @if (!$last && s.items.length > 1) {
                  <span [innerHTML]="i.title"></span><span>,</span><br />
                } 
                @else {
                  <span [innerHTML]="i.title"></span>
                }
              </span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>